module.exports = __webpack_public_path__ + "epdf-app/principal/container/container-3TF4IvL5.html";